import { API, getAsyncThunk } from 'app/api';
import type { SubscribeAction } from 'app/lib/signalr';
import { addBetFactory } from 'app/modules/BetSlip/actions/addBetFactory';

import { matches, objects, sports } from './selectors/entities';

// ---

export const fetchInterestingMatches = getAsyncThunk(
  'MATCHES:INTERESTING_MATCHES',
  API.matches.getInterestingMatches,
);

// --

export const INTERESTING_MATCHES_TOPIC = 'interesting-matches';

export const SUBSCRIBE = 'INTERESTING_MATCHES:SUBSCRIBE';

type SubscribeInterestingMatches = SubscribeAction<typeof SUBSCRIBE, {
  signature: string;
  topic: string;
}>;

export const subscribe = (): SubscribeInterestingMatches => ({
  type: SUBSCRIBE,
  payload: {
    signature: INTERESTING_MATCHES_TOPIC,
    topic: INTERESTING_MATCHES_TOPIC,
  },
});

// ---

export const UNSUBSCRIBE = 'INTERESTING_MATCHES:UNSUBSCRIBE';

type UnsubscribeInterestingMatches = SubscribeAction<typeof UNSUBSCRIBE, {
  topic: string;
}>;

export const unsubscribe = (): UnsubscribeInterestingMatches => ({
  type: UNSUBSCRIBE,
  payload: {
    topic: INTERESTING_MATCHES_TOPIC,
  },
});


export const APPLY_INTERESTING_MATCHES_STATE = 'INTERESTING_MATCHES:APPLY_STATE';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
type iDontKnow = any;

/**
 * Create the "interesting matches apply" action.
 *
 * @param {object} payload
 * @return {ReduxAction}
 */
export const applyInterestingMatches = (payload: iDontKnow) => ({
  type: APPLY_INTERESTING_MATCHES_STATE,
  payload,
});

export const addBet = addBetFactory(matches, sports, objects);

export const SHOW_LIVE_MATCHES = 'INTERESTING_MATCHES:SHOW_LIVE_MATCHES';

export const showLiveMatches = () => ({
  type: SHOW_LIVE_MATCHES,
});
